import { useTranslation } from 'react-i18next';

import { useNotificationAudience } from '../../../hooks/useNotificationAudience';
import { useNotificationMessage } from '../../../hooks/useNotificationMessage';
import { NotificationMessageForm } from '../../molecules/NotificationMessageForm';
import { NotificationMobilePreview } from '../../molecules/NotificationMobilePreview';

/**
 * Etapa 2 do wizard de notificação — composição da mensagem.
 *
 * Exibe o formulário de título/corpo/url ao lado da pré-visualização mobile.
 * Passa a contagem de alunos selecionados para controlar a visibilidade da variável {{nome}}.
 */
export function NotificationMessageStep() {
  const { t } = useTranslation('notification');
  const { title, body, url, updateTitle, updateBody, updateUrl } = useNotificationMessage();
  const { selectedStudentCount } = useNotificationAudience();

  return (
    <div className="flex justify-between flex-row gap-md p-xxs ">
      <div className="flex flex-1 flex-col gap-xxs">
        <div>
          <h2 className="ts-heading-sm text-ctx-content-title">{t('wizard.message.cardTitle')}</h2>
          <p className="ts-paragraph-xs text-ctx-content-base mt-nano">
            {t('wizard.message.cardSubtitle')}
          </p>
        </div>

        <NotificationMessageForm
          title={title}
          body={body}
          url={url}
          studentCount={selectedStudentCount}
          onTitleChange={updateTitle}
          onBodyChange={updateBody}
          onUrlChange={updateUrl}
        />
      </div>
      <NotificationMobilePreview title={title} body={body} />
    </div>
  );
}
